import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './api/queryClient';
import { initTelegram } from './lib/telegram';
import { App } from './App';
import './styles/fonts.css';
import './styles/tokens.css';
import './styles/app.css';
import './styles/shell.css';
import './styles/org.css';

function mount(): void {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </StrictMode>,
  );
}

// Внутри Telegram — mount/ready/expand до первого рендера, чтобы тема и безопасные
// зоны были известны сразу; в обычном браузере initTelegram ничего не делает.
// Сбой инициализации не повод не показать приложение: рисуем в любом случае.
initTelegram().then(mount, mount);
